import React from 'react';
import cx from 'classnames';

import Pictogram from '../global/pictogram';

import TranslatedCopy from '../../intl/translated-copy';

const FormOtpLoginConfirmation = (props) => {
  const {
    codeInicativeAccount,
  } = props;

  const errorcodes = ['17531302', '17531304'];
  const value = !errorcodes.includes(codeInicativeAccount);

  let modalDescriptionCopy = '';

  if (!value) {
    modalDescriptionCopy = codeInicativeAccount === '17531302' ? 'PRO_HOME_LOGIN_BLOCKED_ACCOUNT_DESCRIPTION' : 'PRO_HOME_LOGIN_BLOCKED_OTP_DESCRIPTION';
  } else {
    modalDescriptionCopy = '';
  }

  const modalDescriptionClasses = cx({
    'otpLoginConfirmation-successDescription': true,
    'otpLoginConfirmation-errorDescription': !value && codeInicativeAccount === '17531302',
  });

  const containerClasses = cx({
    'form-otp-login-confirmation-container': true,
    'form-otp-login-confirmation-container-success': value,
    'form-otp-login-confirmation-container-errorOtp': !value && codeInicativeAccount === '17531304',
  });

  return (
    <div className={ containerClasses }>
      { value &&
        <div className='otpLoginConfirmation-main'>
          <div className='otpLoginConfirmation-imageBody'>
            <i className='Icon Icon--password' />
            <Pictogram
              className='CircleOn'
              id='CircleOnNew' />
          </div>
          <TranslatedCopy
            className='otpLoginConfirmation-header'
            copyID='PRO_HOME_LOGIN_SUCCESS_TITLE' />
          <TranslatedCopy
            className={ modalDescriptionClasses }
            copyID='PRO_HOME_LOGIN_SUCCESS_DESCRIPTION' />
        </div>
      }
      { !value &&
        <div className='otpLoginConfirmation-main'>
          <div className='otpLoginConfirmation-imageBody'>
            <i className='Icon Icon--Lock' />
            <Pictogram
              className='CircleOff'
              id='CircleOffNew' />
          </div>
          <TranslatedCopy
            className='otpLoginConfirmation-header'
            copyID='PRO_HOME_LOGIN_BLOCKED_ACCOUNT_TITLE' />
          <h6 className={ modalDescriptionClasses }>
            <TranslatedCopy
              copyID={ modalDescriptionCopy } />
          </h6>
        </div>
      }
    </div>
  );
};

export default FormOtpLoginConfirmation;
